class TSMainCart extends HTMLElement {
  constructor() {
    super();
    this.header = document.querySelector("ts-header");
    this.confirmDeletePopup = this.querySelector("#TSConfirmDelete");
    this.orderRequirementsPopup = document.querySelector("#TSOrderRequirements");

    if (this.header) {
      this.initClickTrigger();
    }
  }

  initClickTrigger() {
    this.addEventListener("click", (e) => {
      if (e.target.hasAttribute("data-trigger")) {
        const currentItem = e.target.closest("[data-variant]");
        const currentItemQuantity = parseInt(currentItem?.querySelector("input[name='quantity']").value);

        switch (e.target.dataset.trigger) {
          case "increase":
            if (currentItemQuantity < 99) {
              this.header.updateQuantity(parseInt(currentItem.dataset.variant), currentItemQuantity + 1);
            }
            break;
          case "decrease":
            if (currentItemQuantity > 1) {
              this.header.updateQuantity(parseInt(currentItem.dataset.variant), currentItemQuantity - 1);
            }
            break;
          case "item-remove":
            this.header.updateQuantity(parseInt(currentItem.dataset.variant), 0);
            break;
          case "confirm-delete":
            this.confirmDeletePopup.classList.remove("open");
            this.clearCart();
            break;
          case "popup-close":
            this.confirmDeletePopup.classList.remove("open");
            break;
          case "checkout":
            e.preventDefault();
            if (parseInt(this.querySelector("[data-total]").dataset.total) > 10000) {
              window.location.pathname = "/checkout";
            } else {
              this.orderRequirementsPopup.classList.add("open");
            }
            break;
          case "clear":
            this.confirmDeletePopup.classList.add("open");
            break;
        }
      }
    })
  }

  clearCart() {
    fetch('/cart/clear.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
    })
    .then(() => {
      window.location.pathname = "/collections/all"
    })
  }
}

customElements.define("ts-cart", TSMainCart);